import { render, staticRenderFns } from "./IcpDialog.vue?vue&type=template&id=2b85137a&scoped=true"
import script from "./IcpDialog.vue?vue&type=script&lang=js"
export * from "./IcpDialog.vue?vue&type=script&lang=js"
import style0 from "./IcpDialog.vue?vue&type=style&index=0&id=2b85137a&prod&scoped=true&lang=css"
import style1 from "./IcpDialog.mobile.css?vue&type=style&index=1&id=2b85137a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b85137a",
  null
  
)

export default component.exports